/**
 * @desc 生成产品条码pdf
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.mskuMap.getProductCodePdf.Params, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/getProductCodePdf`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
